import modelList from '@/configs/modelList.js';
import '@/assets/home.css';

const currentURL = window.location.href;

const modelName = currentURL.split('/').pop();
// const modelPatterns = [
//   /^RM\d{2}01K$/,
//   RP6501K,
//   ST860K
// ];
// const isCustomModel = modelPatterns.some((pattern) => pattern.test(modelName));

// if (isCustomModel){
const listData = modelList[modelName] || [];

const gridContainer = document.createElement('main');
gridContainer.className = 'file-grid';

listData.forEach((item) => {
    const gridItem = document.createElement('a');
    gridItem.className = 'file-grid-item';
    gridItem.href = item.downloadUrl;
    gridItem.target = '_blank';
    gridItem.download = true;
    gridItem.setAttribute('aria-label', `Download ${item.appName}`);

    const flexContainer = document.createElement('div');
    flexContainer.className = 'flex-container';

    const img = document.createElement('img');
    img.className = 'list-item';
    img.src = item.iconUrl;
    img.width = 90;
    img.height = 90;
    img.alt = '';

    const spanText = document.createElement('span');
    spanText.className = 'item-text';
    spanText.textContent = item.appName;

    flexContainer.appendChild(img);
    flexContainer.appendChild(spanText);
    gridItem.appendChild(flexContainer);
    gridContainer.appendChild(gridItem);
});

document.getElementById('app').appendChild(gridContainer);
// } else {
//   import('./main-vue.js').then(({ default: createApp }) => {
//     createApp().mount('#app');
//   });
// }
